export function resolveRobotWebSocketUrl(host: string, port: string, pageUrl: string) {
  const page = new URL(pageUrl)
  const protocol = page.protocol === 'https:' ? 'wss:' : 'ws:'
  const fallback = new URL('/ws', page)
  fallback.protocol = protocol
  // Local HTTP development talks directly to FastAPI; HTTPS uses Caddy /ws.
  if (page.protocol !== 'https:') fallback.port = port.trim() || '8001'
  host = host.trim()
  if (!host) return fallback.toString()

  try {
    const complete = host.includes('://')
    const url = new URL(complete ? host : `${protocol}//${host}`)
    if (!['http:', 'https:', 'ws:', 'wss:'].includes(url.protocol)) return fallback.toString()
    if (!url.hostname) return fallback.toString()
    if (url.protocol === 'http:') url.protocol = 'ws:'
    if (url.protocol === 'https:' || page.protocol === 'https:') url.protocol = 'wss:'
    if (!complete && page.protocol !== 'https:') url.port = port.trim() || '8001'
    if (url.pathname === '/') url.pathname = '/ws'
    return url.toString()
  } catch {
    return fallback.toString()
  }
}

export function useRobotWebSocketUrl() {
  const config = useRuntimeConfig()
  return resolveRobotWebSocketUrl(
    String(config.public.WEBSOCKET_URL || ''),
    String(config.public.ROBOT_PORT || '8001'),
    import.meta.client ? window.location.href : 'http://localhost:3000'
  )
}
